var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRadioSelectedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".radioSelectedStroke{fill:#36a7cd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "radioSelectedStroke",
  d: "M10,.5C4.75.5.5,4.75.5,10s4.25,9.5,9.5,9.5,9.5-4.25,9.5-9.5S15.25.5,10,.5ZM10,18.25c-4.56,0-8.25-3.69-8.25-8.25S5.44,1.75,10,1.75s8.25,3.69,8.25,8.25-3.69,8.25-8.25,8.25Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 3.93
})));
export default SvgRadioSelectedIcon;